<template>
  <div>
    <div v-if="!showUploadArea">
      <fieldset>
        <legend>
          <div style="float: left; width: 100%">
            File Drive Filter
            <span class="input_type">
              <input
                type="radio"
                name="listType"
                id="rbtnDownloadList"
                v-model="fileViewType"
                value="2"
                v-on:change="changeFileView()"
              />
              <label id="lblDownloadList" for="rbtnDownloadList"
                >List of File(s) for Downloading</label
              >
              <input
                type="radio"
                name="listType"
                id="rbtnUploadList"
                v-model="fileViewType"
                value="1"
                v-on:change="changeFileView()"
              />
              <label id="lblDownloadList" for="rbtnUploadList"
                >Uploaded Files</label
              >
            </span>
            <span style="text-align:right;color: #8a0000;font-size: 14px;font-weight: bold">* Fields are mandatory </span>
            <span class="file_count">
              <input
                type="button"
                id="btnBack"
                value="Back To Status"
                v-if="showBack"
                v-on:click="redirectStatusPage()"
              />
              <label id="lblFileCount"
                >File Count : {{ fileUploadedList.length }}</label
              >
            </span>
          </div>
        </legend>
        <div class="Flex_Table">
          <div class="Flex_Row">
            <div class="Flex_Cell" style="width: 25%">
              <label for="ddlAdvertisment" class="mandatorySpan" :class="{ Required: true }"
                >Advertisement For</label
              >
              <select
                id="ddlAdvertisment"
                v-model="advtID"
                v-on:change="getUploadFileList()"
              >
                <option value="-1">---Select---</option>
                <option v-for="c in advtList" :key="c[0]" v-bind:value="c[0]">
                  {{ c[1] }}
                </option>
              </select>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <label for="ddlExamCentre" class="mandatorySpan" :class="{ Required: true }"
                >Exam Centre</label
              >
              <select
                id="ddlExamCentre"
                v-model="dExamCentreID"
                v-on:change="getUploadFileList()"
              >
                <option value="-1">---All---</option>
                <option
                  v-for="c in dExamCentreList"
                  :key="c[0]"
                  v-bind:value="c[0]"
                >
                  {{ c[1] }}
                </option>
              </select>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <label for="ddlDownloadType" class="mandatorySpan" :class="{ Required: true }">{{
                lblDownloadType
              }}</label>
              <select
                id="ddlDownloadType"
                v-model="downloadTypeID"
                v-on:change="getUploadFileList()"
              >
                <option value="-1">---All---</option>
                <option
                  v-for="c in downloadTypeList"
                  :key="c[0]"
                  v-bind:value="c[0]"
                >
                  {{ c[1] }}
                </option>
              </select>
            </div>
            <div class="Flex_Cell" align="right" style="width: 25%">
              <input
                type="button"
                id="btnGetFiles"
                value="Get Files"
                style="margin-top: 20px"
                v-on:click="getUploadFileList()"
              />

              <input
                type="button"
                id="btnClickToUpload"
                value="Click to Upload File"
                style="
                  background-color: black;
                  margin-left: 20px;
                  margin-top: 20px;
                "
                v-on:click="showUpload()"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <div id="dvPagging" v-if="!isShowFileInfo">
        <input
          type="button"
          id="btnPrevious"
          value="<<"
          v-on:click="previousPage()"
        />
        <label for="txtPageNo"
          >Current Page: {{ currentPage }} / Total Page: {{ noOfPages }}</label
        >
        <input type="button" id="btnNext" value=">>" v-on:click="nextPage()" />
        <AcceptInput
          id="txtPageNo"
          v-model="pageJumpNo"
          regExp="([0-9])*"
          maxlength="4"
          title="Enter page no"
          style="width: 50px; text-align: center"
        />
        <input type="button" id="btnGoTo" value="Go" v-on:click="gotoPage()" />
      </div>
      <div id="fileList" v-if="!isShowFileInfo" class="file_list">
        <span
          v-for="file in pageFileUploadList"
          :key="file[0]"
          class="file_info"
          v-on:click="showFileInfo(file)"
        >
          <div class="file_cont">
            <img
              :src="
                file[16] == '1'
                  ? require('../assets/images/ICON/file_thumb.png')
                  : file[16] == '2'
                  ? require('../assets/images/ICON/file_uoload.png')
                  : file[16] == '3'
                  ? require('../assets/images/ICON/file_comp.png')
                  : require('../assets/images/ICON/file_down.png')
              "
              class="file_thumb"
              :status="file[16]"
            />
            <div class="file_prop">
              <span class="name" :status="file[16]">{{ file[0] }}</span> <br />
              <span class="name">{{ file[6] }}</span> <br />
              <span class="exam_centre">{{
                fileViewType == 1 ? file[2] : file[10]
              }}</span>
              <br />
              <span class="upload_type">{{ file[4] }}</span
              ><br />
            </div>
          </div>
        </span>
      </div>
      <div id="fileDetail" v-if="isShowFileInfo">
        <div class="Flex_Table">
          <div class="Flex_Row">
            <div class="Flex_Cell" style="width: 40%">
              <img
                :src="
                  fileInfo[16] == '1'
                    ? require('../assets/images/ICON/file_thumb.png')
                    : fileInfo[16] == '2'
                    ? require('../assets/images/ICON/file_uoload.png')
                    : fileInfo[16] == '3'
                    ? require('../assets/images/ICON/file_comp.png')
                    : require('../assets/images/ICON/file_down.png')
                "
                class="single_file"
                :status="fileInfo[16]"
              />
            </div>
            <div class="Flex_Cell" valign="middle" style="width: 60%">
              <div class="Flex_Table" style="">
                <div class="Flex_Row info_margin">
                  <div class="Flex_Cell" style="width: 30%">
                    <span class="nameS">File Name:</span>
                  </div>
                  <div class="Flex_Cell" style="width: 70%">
                    <span class="nameS">{{ fileInfo[6] }}</span>
                  </div>
                </div>
                <div class="Flex_Row info_margin">
                  <div class="Flex_Cell" style="width: 30%">
                    <span class="exam_centreS">Exam Centre Name:</span>
                  </div>
                  <div class="Flex_Cell" style="width: 70%">
                    <span class="exam_centreS">{{ fileInfo[2] }}</span>
                  </div>
                </div>
                <div class="Flex_Row info_margin">
                  <div class="Flex_Cell" style="width: 30%">
                    <span class="upload_typeS">Upload Type:</span>
                  </div>
                  <div class="Flex_Cell" style="width: 70%">
                    <span class="upload_typeS">{{ fileInfo[4] }}</span>
                  </div>
                </div>
                <div class="Flex_Row info_margin">
                  <div class="Flex_Cell" style="width: 30%">
                    <span class="upload_typeS">Upload By:</span>
                  </div>
                  <div class="Flex_Cell" style="width: 70%">
                    <span class="upload_typeS">{{ fileInfo[8] }}</span>
                  </div>
                </div>
                <div class="Flex_Row info_margin">
                  <div class="Flex_Cell" style="width: 30%">
                    <span class="upload_typeS">Upload By Exam Centre:</span>
                  </div>
                  <div class="Flex_Cell" style="width: 70%">
                    <span class="upload_typeS">{{ fileInfo[10] }}</span>
                  </div>
                </div>
                <div class="Flex_Row info_margin">
                  <div class="Flex_Cell" style="width: 30%">
                    <span class="upload_typeS">Last Download By:</span>
                  </div>
                  <div class="Flex_Cell" style="width: 70%">
                    <span class="upload_typeS">{{ fileInfo[13] }}</span>
                  </div>
                </div>
                <div class="Flex_Row info_margin">
                  <div class="Flex_Cell" style="width: 30%">
                    <span class="upload_typeS">Last Download Time:</span>
                  </div>
                  <div class="Flex_Cell" style="width: 70%">
                    <span class="upload_typeS">{{ fileInfo[11] }}</span>
                  </div>
                </div>
                <div class="Flex_Row info_margin">
                  <div class="Flex_Cell" style="width: 30%">
                    <span class="upload_typeS">Upload Status:</span>
                  </div>
                  <div class="Flex_Cell" style="width: 70%">
                    <span class="upload_typeS">{{ fileInfo[15] }}</span>
                  </div>
                </div>
                <div class="Flex_Row">
                  <div class="Flex_Cell" style="width: 30%"></div>
                  <div class="Flex_Cell" style="float: left; width: 70%">
                    <input
                      type="button"
                      id="btnDownLoadFile"
                      value="Download File"
                      v-if="fileViewType == 2"
                      style="background-color: green; margin-top: 20px"
                      v-on:click="downloadFile($event)"
                    />
                    <input
                      type="button"
                      id="btnRpaDownload"
                      value="DownloadRPA"
                      v-if="fileViewType == 2"
                      style="background-color: green; margin-top: 20px;display:none"
                      v-on:click="downloadFile($event)"
                    />
                    <input type="hidden" id="hfRpaUrl" v-model="RPAURL" />
                    <input
                      type="button"
                      id="btnDelete"
                      value="Delete"
                      v-if="fileViewType == 1"
                      style="background-color: red; margin-top: 20px"
                      v-on:click="deleteFile()"
                    />
                    <input
                      type="button"
                      id="btnClose"
                      value="Close"
                      style="margin-top: 20px"
                      v-on:click="showFileList()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showUploadArea">
      <Fieldset>
        <legend>
          <div style="float: left; width: 100%">
            Filter for File Upload
            <a
              class="glyphicons remove closeCtrl"
              style=""
              v-on:click="showUploadFileList()"
              title="Show uploaded file list"
            ></a>
          </div>
        </legend>
        <div class="Flex_Table">
          <div class="Flex_Row">
            <div class="Flex_Cell">
              <label for="ddlAdvertismentU" class="mandatorySpan" :class="{ Required: true }"
                >Advertisement For</label
              >
              <select id="ddlAdvertismentU" v-model="advtID">
                <option value="-1">---Select---</option>
                <option v-for="c in advtList" :key="c[0]" v-bind:value="c[0]">
                  {{ c[1] }}
                </option>
              </select>
            </div>
            <div class="Flex_Cell">
              <label for="ddlExamCentreU" class="mandatorySpan" :class="{ Required: true }"
                >Exam Centre</label
              >
              <select id="ddlExamCentreU" v-model="uExamCentreID">
                <option value="-1">---Select---</option>
                <option
                  v-for="c in uExamCentreList"
                  :key="c[0]"
                  v-bind:value="c[0]"
                >
                  {{ c[1] }}
                </option>
              </select>
            </div>
            <div class="Flex_Cell">
              <label for="ddlUploadType" class="mandatorySpan" :class="{ Required: true }"
                >Upload Type</label
              >
              <select id="ddlUploadType" v-model="uploadTypeID">
                <option value="-1">---Select---</option>
                <option
                  v-for="c in uploadTypeList"
                  :key="c[0]"
                  v-bind:value="c[0]"
                >
                  {{ c[1] }}
                </option>
              </select>
            </div>
            <div class="Flex_Cell"></div>
          </div>
        </div>
      </Fieldset>
      <fieldset>
        <div id="UploadBox" style="display: block">
          <h2>FILE UPLOADER</h2>
          <span id="UploadArea">
            <label for="FileBox">Choose A File: </label
            ><input
              type="file"
              id="FileBox"
              v-on:change="fileChosen($event)"
            /><br />
            <label for="NameBox">Name:{{ Name }} </label><br />
            <button
              type="button"
              id="UploadButton"
              class="Button"
              v-on:click="startUpload()"
            >
              Upload
            </button>
          </span>
          <span id="UploadProgress" style="display: none">
            <span id="NameArea">UPLOADING : {{ SelectedFile.name }}</span>
            <div id="ProgressContainer"><div id="ProgressBar"></div></div>
            <center>
              <span id="percent">0%</span>
              <span id="Uploaded">
                - <span id="MB">0</span> /
                {{ Math.round(SelectedFile.size / 1048576) }} MB</span
              >
            </center>
            <button
              type="button"
              id="OkButton"
              class="Button"
              v-if="showUploadOk"
              v-on:click="uploadComplete()"
            >
              Ok
            </button>
          </span>
        </div>
      </fieldset>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import axios from "axios";
import config from "@/router/globalConfig";
import AcceptInput from "./ekkControls/AcceptInput";
export default {
  name: "FileDrive",
  components: {
    AcceptInput: AcceptInput
  },
  data() {
    return {
      showBack: false,
      showUploadArea: false,
      showUploadOk: false,
      fileViewType: 2,
      lblDownloadType: "Download Type",
      advtID: -1,
      dExamCentreID: -1,
      uExamCentreID: -1,
      downloadTypeID: -1,
      uploadTypeID: -1,
      fileUploadedList: [],
      advtList: [],
      dExamCentreList: [],
      downloadTypeList: [],
      uExamCentreList: [],
      uploadTypeList: [],

      SelectedFile: new Object(),
      FReader: null,
      Name: null,
      UploadSize: 0,
      Files: [],

      isShowFileInfo: false,
      fileInfo: null,
      RPAURL: "",
      noOfPages: 0,
      perPageRecord: 9,
      currentPage: 0,
      pageJumpNo: "",
      pageFileUploadList: []
    };
  },
  mounted() {
    if (this.$root.$data.StatusData != null) {
      this.showBack = true;
      this.fileViewType = this.$root.$data.StatusData.EventType;
      this.dExamCentreID = this.$root.$data.StatusData.ExamCentreID;
      this.downloadTypeID = this.$root.$data.StatusData.BackupTypeID;
    }
    this.getAdvt();
  },
  methods: {
    changeFileView() {
      this.fileUploadedList = [];
      this.dExamCentreID = -1;
      this.downloadTypeID = -1;
      this.getExamCentre(1, false);
      this.getUploadFileList();
    },
    getAdvt() {
      const _data_ = { type: "2" };
      axios
        .get(config.WEB_API_PATH + "Master/GetAdvertisment", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            this.advtList = response.data;
            if (this.advtList.length > 0) {
              this.advtID = this.advtList[0][0];
            }
            this.getExamCentre(2, false);
          },
          error => {}
        );
    },
    getExamCentre(centreType, viewForUpload) {
      if (this.fileViewType == 1) centreType = 1;
      if (this.fileViewType == 2) centreType = 2;
      if (viewForUpload) centreType = 1;
      let _data_ = { type: centreType };
      axios
        .get(config.WEB_API_PATH + "FileDrive/GetExamCentre", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            if (viewForUpload == false) {
              this.dExamCentreList = response.data;
              // if (this.$root.$data.StatusData != null) {
              //   this.dExamCentreID = this.$root.$data.StatusData.ExamCentreID;
              // }
              this.getDownloadType();
            }
            if (viewForUpload == true) {
              this.uExamCentreList = response.data;
              // if (this.$root.$data.StatusData != null) {
              //   this.dExamCentreID = this.$root.$data.StatusData.ExamCentreID;
              // }
              this.getUploadType();
            }
          },
          error => {}
        );
    },
    getDownloadType() {
      const _data_ = {};
      let apiPath = "";
      if (this.fileViewType == 2) {
        this.lblDownloadType = "Download Type";
        apiPath = config.WEB_API_PATH + "FileDrive/GetDownloadType";
      }
      if (this.fileViewType == 1) {
        this.lblDownloadType = "Upload Type";
        apiPath = config.WEB_API_PATH + "FileDrive/GetUploadType";
      }
      axios
        .get(apiPath, {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            this.downloadTypeList = response.data;
            if (this.$root.$data.StatusData != null) {
              let me = this;
              vue.nextTick(function() {
                me.getUploadFileList();
              });
            }
          },
          error => {}
        );
    },
    getUploadType() {
      const _data_ = {};
      axios
        .get(config.WEB_API_PATH + "FileDrive/GetUploadType", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            this.uploadTypeList = response.data;
            if (this.$root.$data.StatusData != null) {
              let me = this;
              vue.nextTick(function() {
                me.getUploadFileList();
              });
            }
          },
          error => {}
        );
    },
    getUploadFileList() {
      if (this.advtID == null || this.advtID == -1) {
        window.MessageBox.show({
          message: "Please select advertisment ",
          type: "error",
          title: "Message"
        });
        return false;
      }
      let ddlVal = document.getElementById("ddlDownloadType").value;
      if (ddlVal == null || ddlVal.trim().length == 0) {
        window.MessageBox.show({
          message: "Please select " + this.lblDownloadType,
          type: "error",
          title: "Message"
        });
        return false;
      }
      this.showFileList();
      let type = "";
      if (this.fileViewType == 2) {
        type = "2";
      }
      if (this.fileViewType == 1) {
        type = "1";
      }
      const _data_ = {
        advtID: this.advtID,
        examCentreID: this.dExamCentreID,
        uploadTypeID: this.downloadTypeID,
        type: type
      };
      axios
        .get(config.WEB_API_PATH + "FileDrive/GetUploadFile", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            this.fileUploadedList = response.data;
            this.filesPagging();
          },
          error => {}
        );
    },
    filesPagging() {
      this.noOfPages = 0;
      this.currentPage = 0;
      this.pageJumpNo = "";
      this.pageFileUploadList = [];
      let totalFileCount = this.fileUploadedList.length;
      this.noOfPages = Math.ceil(
        parseFloat(totalFileCount / this.perPageRecord)
      );
      this.nextPage();
    },
    previousPage() {
      this.currentPage--;
      if (this.currentPage <= 0) {
        // window.MessageBox.show({
        //   message: "No more data found",
        //   type: "error",
        //   title: "Message",
        // });
        FlashMessage.show(
          "<span style='color:red'>No more data found.</span>",
          1000
        );
        this.currentPage = 1;
        return false;
      }
      this.pageFileUploadList = [];
      let startIndex = 0;
      let endIndex = this.perPageRecord;
      if (this.currentPage != 1) {
        startIndex =
          this.currentPage * this.perPageRecord - 1 - this.perPageRecord;
        endIndex = this.currentPage * this.perPageRecord - 1;
      }
      if (endIndex > this.fileUploadedList.length)
        endIndex = this.fileUploadedList.length;

      for (startIndex; startIndex < endIndex; startIndex++) {
        this.pageFileUploadList.push(this.fileUploadedList[startIndex]);
        //this.pageFileUploadList[index]=this.fileUploadedList[startIndex];
        //index++;
      }
    },
    nextPage() {
      if (this.currentPage >= this.noOfPages) {
        // window.MessageBox.show({
        //   message: "No more data found",
        //   type: "error",
        //   title: "Message",
        // });
        FlashMessage.show(
          "<span style='color:red'>No more data found.</span>",
          1000
        );
        return false;
      }

      this.pageFileUploadList = [];
      let startIndex = 0;
      if (this.currentPage != 0) {
        startIndex = this.currentPage * this.perPageRecord;
      }
      this.currentPage++;
      let endIndex = this.currentPage * this.perPageRecord;
      if (endIndex > this.fileUploadedList.length)
        endIndex = this.fileUploadedList.length;
      for (startIndex; startIndex < endIndex; startIndex++) {
        this.pageFileUploadList.push(this.fileUploadedList[startIndex]);
      }
    },
    gotoPage() {
      if (this.pageJumpNo == "" || this.pageJumpNo == 0) {
        window.MessageBox.show({
          message: "Please enter page no",
          type: "error",
          title: "Message"
        });
        return false;
      }
      if (this.pageJumpNo > this.noOfPages) {
        window.MessageBox.show({
          message: "this page no is not exist",
          type: "error",
          title: "Message"
        });
        return false;
      }
      this.currentPage = this.pageJumpNo;

      this.pageFileUploadList = [];
      let startIndex = 0;
      let endIndex = this.perPageRecord;
      if (this.currentPage != 1) {
        startIndex =
          this.currentPage * this.perPageRecord - 1 - this.perPageRecord;
        endIndex = this.currentPage * this.perPageRecord - 1;
      }
      for (startIndex; startIndex < endIndex; startIndex++) {
        this.pageFileUploadList.push(this.fileUploadedList[startIndex]);
      }
    },
    showUploadFileList() {
      this.showUploadArea = false;
    },
    showUpload() {
      if (window.File && window.FileReader) {
        this.showUploadArea = true;
        this.getExamCentre(1, true);
        if (this.fileViewType == 1) {
          let me = this;
          vue.nextTick(function() {
            me.uExamCentreID = me.dExamCentreID;
            me.uploadTypeID = me.downloadTypeID;
          });
        }
      } else {
        //document.getElementById("UploadArea").innerHTML =
        alert(
          "Your Browser Doesn't Support The File API Please Update Your Browser"
        );
      }
    },
    fileChosen(evnt) {
      this.SelectedFile = evnt.target.files[0];
      this.Name = this.SelectedFile.name;
    },
    createUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    startUpload() {
      var me = this;
      if (this.advtID == null || this.advtID == -1) {
        window.MessageBox.show({
          message: "Please select advertisment ",
          type: "error",
          title: "Message"
        });
        return false;
      }
      if (this.uExamCentreID == null || this.uExamCentreID == -1) {
        window.MessageBox.show({
          message: "Please select exam centre",
          type: "error",
          title: "Message"
        });
        return false;
      }
      if (this.uploadTypeID == null || this.uploadTypeID == -1) {
        window.MessageBox.show({
          message: "Please select upload type ",
          type: "error",
          title: "Message"
        });
        return false;
      }
      if (document.getElementById("FileBox").value != "") {
        this.showProgress = true;
        this.FReader = new FileReader();
        // var Content =
        //   "<span id='NameArea'>Uploading " +
        //   this.SelectedFile.name +
        //   " as " +
        //   this.Name +
        //   "</span>";
        // Content +=
        //   '<div id="ProgressContainer"><div id="ProgressBar"></div></div><span id="percent">50%</span>';
        // Content +=
        //   "<span id='Uploaded'> - <span id='MB'>0</span>/" +
        //   Math.round(this.SelectedFile.size / 1048576) +
        //   "MB</span>";
        //document.getElementById("UploadArea").innerHTML = Content;
        document.getElementById("UploadArea").style.display = "none";
        document.getElementById("UploadProgress").style.display = "block";
        var Place = 0;
        var Percent = 0;
        this.Files[this.Name] = {
          //Create a new Entry in The Files Variable
          AdvtID: this.advtID,
          ExamCentreID: this.uExamCentreID,
          UploadTypeID: this.uploadTypeID,
          FileSize: this.SelectedFile.size,
          FileName: this.Name,
          SaveFileName: this.createUUID() + "." + this.Name.split(".").pop(),
          Data: "",
          IsRetry: false,
          IsAppend: false,
          Downloaded: 0
        };
        this.FReader.onload = function(evnt) {
          //socket.emit('Upload', { 'Name' : Name, Data : evnt.target.result });
          var formData = new FormData();
          formData.append("fileInfo", JSON.stringify(me.Files[me.Name]));
          formData.append("file", evnt.target.result);

          axios
            .post(config.WEB_API_PATH + "FileDrive/UploadFiles", formData, {
              headers: {
                __RequestVerificationToken: config.AF_Token,
                Authorization: config.LOG_Token
              },
              onUploadProgress: function(progressEvent) {}.bind(me),
              crossdomain: true
            })
            .then(
              response => {
                //console.log(response);
                //this.Files[this.Name]['Downloaded'] += data['Data'].length;
                me.Files[me.Name]["Downloaded"] += response.data;
                if (
                  me.Files[me.Name]["Downloaded"] <
                  me.Files[me.Name]["FileSize"]
                ) {
                  //If File is Fully Uploaded
                  me.Files[me.Name]["Data"] = ""; //Reset The Buffer
                  Place = me.Files[me.Name]["Downloaded"] / 524288;
                  Percent =
                    (me.Files[me.Name]["Downloaded"] /
                      me.Files[me.Name]["FileSize"]) *
                    100;
                  me.Files[me.Name]["IsRetry"] = false;
                  me.Files[me.Name]["IsAppend"] = true;
                  me.synchData({ Place: Place, Percent: Percent });
                }
                if (
                  me.Files[me.Name]["Downloaded"] ==
                  me.Files[me.Name]["FileSize"]
                ) {
                  me.updateBar(100);
                  me.showUploadOk = true;
                }
              },
              error => {
                //console.log(error.response);
                /*
                if (error.response == undefined) {
                  alert("Error:" + error);
                } else {
                  if (error.response.status == "415") {
                    alert("Error: " + error.response.statusText);
                  } else {
                    if (error.response.data.message == undefined) {
                      alert("Error: " + error.response.data);
                    } else {
                      alert("Error: " + error.response.data.message);
                    }
                  }
                }*/
                if (error != undefined && error.response != undefined) {
                  if (error.response.status == "587") {
                    alert("Error: " + error.response.statusText);
                    this.showProgress = false;
                     document.getElementById("UploadArea").style.display = "block";
                     document.getElementById("UploadProgress").style.display = "none";
                  } else {
                    me.Files[me.Name]["IsRetry"] = true;
                    me.synchData({ Place: Place, Percent: Percent });
                  }
                } else {
                  me.Files[me.Name]["IsRetry"] = true;
                  me.synchData({ Place: Place, Percent: Percent });
                }
              },
              failure => {
                alert("Failure: " + failure);
              }
            );
        };
        this.synchData({ Place: 0, Percent: 0 });
      } else {
        //alert("Please Select A File");
        window.MessageBox.show({
          message: "Please select a file",
          type: "error",
          title: "Message"
        });
      }
    },
    synchData(data) {
      this.updateBar(data["Percent"]);
      var Place = data["Place"] * 524288; //The Next Blocks Starting Position
      var NewFile; //The Variable that will hold the new Block of Data
      if (this.SelectedFile.webkitSlice)
        NewFile = this.SelectedFile.slice(
          Place,
          Place + Math.min(524288, this.SelectedFile.size - Place)
        );
      else
        NewFile = this.SelectedFile.slice(
          Place,
          Place + Math.min(524288, this.SelectedFile.size - Place)
        );
      this.UploadSize = NewFile.size;
      this.FReader.readAsDataURL(NewFile);
    },
    updateBar(percent) {
      document.getElementById("ProgressBar").style.width = percent + "%";
      document.getElementById("percent").innerHTML =
        Math.round(percent * 100) / 100 + "%";
      var MBDone = Math.round(
        ((percent / 100.0) * this.SelectedFile.size) / 1048576
      );
      document.getElementById("MB").innerHTML = MBDone;
    },
    uploadComplete() {
      document.getElementById("UploadArea").style.display = "block";
      document.getElementById("UploadProgress").style.display = "none";
      document.getElementById("FileBox").value = "";
      this.SelectedFile = new Object();
      this.FReader = null;
      this.Name = null;
      this.UploadSize = 0;
      this.Files = [];
      this.showUploadOk = false;
    },
    showFileInfo(file) {
      this.isShowFileInfo = true;
      this.fileInfo = file;
    },
    showFileList() {
      this.isShowFileInfo = false;
      this.fileInfo = null;
    },
    deleteFile() {
      let result = confirm("Are you sure to delete this file?");
      const _data_ = {
        advtID: this.advtID,
        fileID: this.fileInfo[0]
      };
      axios
        .get(config.WEB_API_PATH + "FileDrive/DeleteSaveFile", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            let data = response.data;
            if (data.isSuccess) {
              window.MessageBox.show({
                message: data.msg,
                type: "success",
                title: "Message"
              });
            } else {
              window.MessageBox.show({
                message: data.msg,
                type: "error",
                title: "Message"
              });
            }
          },
          error => {}
        );
    },
    downloadFile(event) {
      event.target.setAttribute("disabled", "disabled");
      let isRPACall = false;
      if (event.target.value == "DownloadRPA") isRPACall = true;

      this.RPAURL = "";
      const _data_ = {
        docFileID: this.fileInfo[0]
      };
      axios
        .get(config.WEB_API_PATH + "FileDrive/GetDownloadFile", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            let data = response.data;
            if (data.isSuccess) {
              //console.log(response);
              const downloadUrl =
                config.WEB_API_PATH + "FileDrive/DownloadFiles/" + data.result;
              if (isRPACall) {
                this.RPAURL = downloadUrl;
              } else {
                const link = document.createElement("a");
                link.href = downloadUrl;
                document.body.appendChild(link);
                link.click();
                link.remove();
              }
            } else {
              window.MessageBox.show({
                message: data.msg,
                type: "error",
                title: "Message"
              });
            }
            event.target.removeAttribute("disabled");
          },
          error => {
            event.target.removeAttribute("disabled");
          }
        );
    },
    redirectStatusPage() {
      this.$router.push({ name: "UploadDownloadStatus" });
    }
  },
  beforeDestroy() {
    this.$root.$data.StatusData == null;
  }
};
</script>
<style scoped>
.file_list {
  border: solid black 2px;
  border-radius: 5px 5px;
  margin: 2px;
  display: inline-block;
  height: calc(100vh - 228px);
  overflow: auto;
  width: 99.7%;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  padding: 0;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
h2 {
  font-size: 25px;
  margin-bottom: 10px;
  border-bottom: solid;
}
#NameArea,
#percent,
#Uploaded {
  color: #2d1048;
  font-size: 14px;
  font-weight: bold;
}
.file_info {
  width: 33%;
  float: left;
}
.file_cont {
  width: 100%;
  display: block;
  position: relative;
  height: 100%;
  margin: 0 auto;
  vertical-align: middle;
  cursor: pointer;
}
.file_info:hover {
  background-color: #f1fff7;
}
.file_prop {
  padding-top: 40px;
  position: relative;
  height: 100%;
  text-align: left;
}
.name {
  color: #2d1048;
  font-size: 12px;
  font-weight: bold;
}
.exam_centre {
  color: #1fa96f;
  font-size: 11px;
  font-weight: bold;
}
.upload_type {
  color: #762bca;
  font-size: 11px;
  font-weight: bold;
}
.file_count {
  color: #8a0000;
  font-size: 16px;
  font-weight: bold;
  float: right;
  margin-top: 5px;
}
.file_thumb {
  max-width: 230px;
  max-height: 130px;
  display: inline;
  float: left;
  position: relative;
  height: 100%;
  text-align: center;
}
.nameS {
  color: #2d1048;
  font-size: 16px;
  font-weight: bold;
}
.exam_centreS {
  color: #1fa96f;
  font-size: 14px;
  font-weight: bold;
}
.upload_typeS {
  color: #762bca;
  font-size: 14px;
  font-weight: bold;
}
.file_thumb {
  max-width: 230px;
  max-height: 130px;
  display: inline;
  float: left;
  position: relative;
  height: 100%;
  text-align: center;
}
.single_file {
  max-width: 400px;
  max-height: 350px;
}
#ProgressContainer {
  width: 575px;
  height: 36px;
  background: #f8f8f8;
  margin-top: 14px;
  border: 1px solid #e8e8e8;
  border-top: 1px solid #d8d8d8;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 2px;
}

#ProgressBar {
  height: 100%;
  width: 0%;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#a50aad),
    color-stop(0.5, #6b0d6b),
    to(#4a074a)
  );
}

#UploadBox {
  background: #8fdad7;
  padding: 10px;
  position: relative;
  top: 50%;
  left: 28%;
  height: 200px;
  width: 600px;
  border: 1px solid #dfdfdf;

  -webkit-box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);

  -webkit-border-radius: 11px;
  -moz-border-radius: 11px;
  border-radius: 11px;
}

button.Button {
  font-size: 18px;
  color: #ffffff;
  padding: 8px 30px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#a50aad),
    color-stop(0.5, #6b0d6b),
    to(#4a074a)
  );

  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 1px solid #5b139e;

  -webkit-box-shadow: 0px 1px 3px rgba(000, 000, 000, 0.5),
    inset 0px 0px 3px rgba(255, 255, 255, 0.4);
  -moz-box-shadow: 0px 1px 3px rgba(000, 000, 000, 0.5),
    inset 0px 0px 3px rgba(255, 255, 255, 0.4);
  box-shadow: 0px 1px 3px rgba(000, 000, 000, 0.5),
    inset 0px 0px 3px rgba(255, 255, 255, 0.4);
  text-shadow: 0px -1px 0px rgba(000, 000, 000, 0.1),
    0px 1px 0px rgba(145, 035, 145, 1);
  position: absolute;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
}

button.Button:hover {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#a50aad),
    color-stop(0.8, #6b0d6b),
    to(#a50aad)
  );
  color: #d3d3d3;
}

button.Button:active {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#4a074a),
    color-stop(0.8, #6b0d6b),
    to(#a50aad)
  );
}

input {
  margin-top: 10px;
  margin-bottom: 8px;
}

input[type="text"] {
  border: 1px solid #cdcdcd;
  border-top: 1px solid #676767;

  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  font-size: 18px;
  padding: 2px;
  width: 300px;
  margin-left: 10px;
}

.closeCtrl {
  float: right;
  padding: 2px 5px;
  border: solid 1px rgba(255, 255, 255, 0.1);
  background-color: rgba(0, 0, 0, 0.3);
  transition: all 300ms;
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.2)
  );
  margin: 1px;
  border-radius: 5px;
}
.closeCtrl:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.closeCtrl:active {
  border: solid 1px rgba(255, 255, 255, 0.5);
}
.input_type {
  background-color: #54e2e8;
  padding: 6px;
  border-radius: 2px 2px;
  color: #8a0000;
  font-size: 14px;
  font-weight: bold;
}
.info_margin {
  margin-top: 5px;
  border-bottom: magenta dotted 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/FileDrive.vue